<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<ng-container *ngIf='!dataLoading'>
  <div mat-dialog-title>
    <h2>{{"general.Edit Profile" | translate}}</h2>
    <button mat-icon-button (click)="openConfirmDialog()" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="formGroup">
    <mat-dialog-content>
      <div class="mat-dialog-body">

        <div class="fields-group">
          <div class="image-uploader">
            <div class="upload-container">
              <label [for]="'fileUploadInput'">
                <input type='file' class="img-viewer" [id]="'fileUploadInput'"
                  accept="image/jpeg, image/pjpeg, image/png" (change)="changeFileListener($event)">
                <div class="image-preview photo">
                  <img [src]="logoSrc" *ngIf="logoSrc">
                </div>
              </label>
            </div>
            <div>
              <label>{{ 'content5.Team Member Photo' | translate }}</label>
              <p>
                {{ 'content5.JPG or PNG' | translate }}
                <span>({{ 'content5.MB max' | translate: {no: 1} }})</span>
              </p>
            </div>
          </div>
          <!-- <p class="has-error" *ngIf="!logoSrc && isSubmitted && !(fileTypeError || fileSizeError)">{{ 'forms.Required' | translate }}</p> -->
          <p class="has-error" *ngIf="fileTypeError">{{ 'forms.InvalidFile' | translate }}</p>
          <p class="has-error" *ngIf="fileSizeError">{{ 'forms.Max-file-size' | translate }} {{maxFileSize}} {{
            'forms.MB' | translate }}</p>
        </div>

        <div class="fields-group">
          <mat-form-field class="form-group" hideRequiredMarker>
            <mat-label>{{"forms.First name" | translate}}</mat-label>
            <input matInput formControlName="fName" maxlength="50">
            <mat-error *ngIf="hasError('fName', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <!-- <mat-error *ngIf="hasError('fName', 'pattern')">{{ 'forms.Invalid value' | translate }}</mat-error> -->
          </mat-form-field>

          <mat-form-field class="form-group" hideRequiredMarker>
            <mat-label>{{"forms.Last name" | translate}}</mat-label>
            <input matInput formControlName="lName" maxlength="50">
            <mat-error *ngIf="hasError('lName', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <!-- <mat-error *ngIf="hasError('lName', 'pattern')">{{ 'forms.Invalid value' | translate }}</mat-error> -->
          </mat-form-field>

          <app-phone-number
            [formGroup]="formGroup"
            [controlName]="'phoneNumber'"
            name="phoneNumber"
            [required]="true"
            [isSubmitted]='isSubmitted'
            [selectedCountry]="selectedCountry">
          </app-phone-number>

          <mat-form-field class="form-group">
            <mat-label>{{"forms.Email" | translate}}</mat-label>
            <input matInput formControlName="email" maxlength="50">
            <mat-error *ngIf="hasError('email', 'required')">{{ 'forms.Required' | translate }}</mat-error>
            <mat-error *ngIf="hasError('email', 'pattern')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
          </mat-form-field>

          <mat-form-field class="form-group" hideRequiredMarker>
            <mat-label>{{ 'forms.Nationality' | translate }}</mat-label>
            <mat-select formControlName="nationalityId">
              <mat-option [value]="nationality.id" *ngFor="let nationality of nationalities">
                <span>{{nationality.name}}</span>
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('nationalityId', 'required')">
              {{ 'forms.Required' | translate }}
            </mat-error>
          </mat-form-field>

          <app-datepicker
            [label]="'forms.Date of birth' | translate"
            [max]='maxDate' [formGroup]="formGroup"
            [controlName]="'birthDate'"
            [isSubmitted]='isSubmitted'
            [showToday]="false"
            (selectedDateChanged)="formGroup.controls['birthDate'].setValue($event)">
          </app-datepicker>

          <div class="form-group">
            <div class="group-title">{{"forms.Gender" | translate}}</div>
            <mat-radio-group formControlName="gender">
              <mat-radio-button *ngFor="let item of genderList" [value]="item.lookupcode">{{item.name}}</mat-radio-button>
            </mat-radio-group>
          </div>

        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button type="button" (click)="openConfirmDialog()" class="btn-grey">{{"forms.Cancel" | translate}}</button>

      <button (click)="saveProfile()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
        {{"general.Edit Profile" | translate}}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
